import type { KyInstance } from 'ky';

import { ensureError } from '@enterprise/core';
import type { OperationResultWithData } from '@enterprise/types';

import { Uri } from '#constants/uri';

import type { BlueprintPagedData } from './types/blueprint-paged-data.type';
import type { PagedBlueprintQuery } from './types/paged-blueprint-query.type';

/**
 * Fetches a paginated list of blueprints from the API using the provided Ky instance and query parameters.
 *
 * @param instance - The Ky HTTP client instance used to make the request.
 * @param query - The query parameters for pagination and filtering of blueprints.
 * @returns A promise that resolves to an `OperationResultWithData` containing `BlueprintPagedData`.
 * @throws Will throw an error if the HTTP request fails.
 */
export const getPagedBlueprints = async (instance: KyInstance, query: PagedBlueprintQuery) => {
  try {
    return await instance
      .get<OperationResultWithData<BlueprintPagedData>>(Uri.blueprint.getPaged, {
        searchParams: {
          ...query,
        },
      })
      .json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
